import Routers from './router'
import supplierStore from './store'
export default{
	install(Vue,{router,store}){
		router.addRoute(Routers);
		store.registerModule('supplierModule', supplierStore)
	}
}